import { render, staticRenderFns } from "./txtMsg.vue?vue&type=template&id=6f24daf5&scoped=true"
import script from "./txtMsg.vue?vue&type=script&lang=js"
export * from "./txtMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24daf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f24daf5')) {
      api.createRecord('6f24daf5', component.options)
    } else {
      api.reload('6f24daf5', component.options)
    }
    module.hot.accept("./txtMsg.vue?vue&type=template&id=6f24daf5&scoped=true", function () {
      api.rerender('6f24daf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/msg/txtMsg.vue"
export default component.exports